import Util from "@/utils/util";
const topHeight = 200;
const top = "-2.7rem";

var pk = document.body.scrollWidth;
var pg = document.body.scrollHeight;
var pointX, pointY, targetX, targetY;

function getAngle(angx, angy) {
  return (Math.atan2(angy, angx) * 180) / Math.PI;
}

//根据起点终点返回方向 1向上 2向下 3向左 4向右 0未滑动
function getDirection(startx, starty, endx, endy) {
  var angx = endx - startx;
  var angy = endy - starty;
  var result = 0;

  //如果滑动距离太短
  if (Math.abs(angx) < 2 && Math.abs(angy) < 2) {
    return result;
  }

  var angle = getAngle(angx, angy);
  if (angle >= -135 && angle <= -45) {
    result = 1;
  } else if (angle > 45 && angle < 135) {
    result = 2;
  } else if (
    (angle >= 135 && angle <= 180) ||
    (angle >= -180 && angle < -135)
  ) {
    result = 3;
  } else if (angle >= -45 && angle <= 45) {
    result = 4;
  }

  return result;
}

let RefreshUtil = {
  isDown: false,
  handleTouchStart(event) {
    this.startY = event.touches[0].clientY;
    this.startX = event.touches[0].clientX;
    this.translateY = 0;

    Util.removeClass(this.option.scrollHtml, "refreshing");
  },
  handleTouchMove(event) {
    const dir = getDirection(
      this.startX,
      this.startY,
      event.touches[0].clientX,
      event.touches[0].clientY
    );
    if (dir !== 2) {
      return;
    }
    this.isDown = true;
    let me = this;
    if (window.top !== window) {
      return;
    }
    let scrollTop =
      me.option.scrollDom.scrollTop ||
      document.documentElement.scrollTop ||
      window.pageYOffset ||
      document.body.scrollTop;
    if (scrollTop > 0) return;
    me.currentY = event.touches[0].clientY;
    me.translateY = parseFloat(me.currentY - me.startY);
    if (me.translateY > 0) {
      document.body.addEventListener("touchmove", RefreshUtil.preventDefault, {
        passive: false
      }); //passive 参数不能省略，用来兼容ios和android
    }
    if (me.translateY >= topHeight) {
      me.translateY = topHeight;
    }
    if (me.translateY < 0) {
      me.translateY = top;
    }
    RefreshUtil.setTransform(me.option.scrollHtml, me.translateY / 5 + "px");

    let targetY = event.targetTouches[0].pageY;
    if (targetY <= 0) {
      // 超出边界执行ontouchend
      me.ontouchend();
    }
  },
  handleTouchEnd(event) {
    document.body.removeEventListener("touchmove", RefreshUtil.preventDefault, {
      passive: false
    });
    if (!this.isDown) {
      return;
    }
    let me = this;
    let scrollTop =
      me.option.scrollDom.scrollTop ||
      document.documentElement.scrollTop ||
      window.pageYOffset ||
      document.body.scrollTop;
    if (scrollTop > 0) return;
    if (me.translateY >= topHeight) {
      me.option.expression().then(() => {
        RefreshUtil.setTransform(me.option.scrollHtml, top);
        setTimeout(() => {
          Util.removeClass(me.option.scrollHtml, "refreshing");
        }, 500);
      });
      Util.addClass(me.option.scrollHtml, "refreshing");
    } else {
      RefreshUtil.setTransform(me.option.scrollHtml, top);
    }
    this.isDown = false;
  },
  handleTouchCancle() {
    document.body.removeEventListener("touchmove", RefreshUtil.preventDefault, {
      passive: false
    });
    RefreshUtil.setTransform(me.option.scrollHtml, top);
  },
  preventDefault(e) {
    if (e.cancelable) {
      e.preventDefault();
    } //阻止默认的处理方式(阻止下拉滑动的效果)
  },
  setTransform(dom, a) {
    dom.style.transform = `translate3d(0,${a},0)`;
    dom.style.wekitTransform = `translate3d(0,${a},0)`;
  },
  updateEL(el, context) {
    let scrollDom = context.data.attrs ? context.data.attrs["scrollDom"] : null;
    if (!scrollDom) {
      scrollDom = document.documentElement;
    } else {
      scrollDom = document.querySelector(scrollDom);
      scrollDom = scrollDom || document.documentElement;
    }
    el.option.scrollDom = scrollDom;
  }
};
export default {
  bind: function(el, binding, context) {
    // 当被绑定的元素插入到 DOM 中时……
    el.option = {
      el,
      expression: binding.value
    };
  },
  inserted: function(el, binding, context) {
    let pos = window.getComputedStyle(el, null).position,
      html = null,
      scrollDom;

    if (!el.option.expression || typeof el.option.expression !== "function") {
      return;
    }
    RefreshUtil.updateEL(el, context);
    /* scrollDom = context.data.attrs ? context.data.attrs['scrollDom'] : null;
		if (!scrollDom) {
			scrollDom = document.documentElement
		} else {
			scrollDom = document.querySelector(scrollDom);
		}
		el.option.scrollDom = scrollDom; */

    html = document.createElement("div");
    html.className = "refresh-top";
    el.insertBefore(html, el.children[0]);
    el.option.scrollHtml = html;

    el.style.position = pos !== "static" ? pos : "relative";
    Util.addClass(el, "refresh-animate");

    el.addEventListener("touchstart", RefreshUtil.handleTouchStart);
    el.addEventListener("touchmove", RefreshUtil.handleTouchMove);
    el.addEventListener("touchend", RefreshUtil.handleTouchEnd);
    el.addEventListener("touchcancle", RefreshUtil.handleTouchCancle);
  },
  update: function(el, binding, context) {
    RefreshUtil.updateEL(el, context);
  },
  componentUpdated: function() {},
  unbind: function(el) {
    el.removeEventListener("touchstart", RefreshUtil.handleTouchStart);
    el.removeEventListener("touchmove", RefreshUtil.handleTouchMove);
    el.removeEventListener("touchend", RefreshUtil.handleTouchEnd);
    el.removeEventListener("touchend", RefreshUtil.handleTouchCancle);
    document.body.removeEventListener("touchmove", RefreshUtil.preventDefault, {
      passive: false
    });
  }
};
